import { render, staticRenderFns } from "./changepassword.vue?vue&type=template&id=6b5d0701"
import script from "./changepassword.vue?vue&type=script&lang=js"
export * from "./changepassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/python/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5d0701')) {
      api.createRecord('6b5d0701', component.options)
    } else {
      api.reload('6b5d0701', component.options)
    }
    module.hot.accept("./changepassword.vue?vue&type=template&id=6b5d0701", function () {
      api.rerender('6b5d0701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/changepassword.vue"
export default component.exports